import { render, staticRenderFns } from "./CSVC.vue?vue&type=template&id=45eb9206&scoped=true"
import script from "./CSVC.vue?vue&type=script&lang=js"
export * from "./CSVC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45eb9206",
  null
  
)

export default component.exports